module.exports = __webpack_public_path__ + "img/22.88bcb39f.jpg";